import React, { useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { useEmpresasLanguage } from "../../context/EmpresasLanguageContext";
import {
  consejoEmpresarialSumapaz,
  CEZ_PATH,
} from "../../data/consejoEmpresarialSumapazData";
import CezLogo from "../cez/CezLogo";

function NavbarCez() {
  const { lang } = useEmpresasLanguage();
  const c = consejoEmpresarialSumapaz[lang] || consejoEmpresarialSumapaz.es;
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `whitespace-nowrap rounded-lg px-3 py-2 text-sm font-bold transition ${
      isActive
        ? "bg-white/15 text-amber-300"
        : "text-slate-200 hover:bg-white/10 hover:text-white"
    }`;

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-50 border-b border-[#123a72] bg-[#0b1f3f] text-white shadow-md">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6 lg:px-8">
          <Link to={CEZ_PATH} className="flex min-w-0 items-center gap-3 group" onClick={() => setMobileOpen(false)}>
            <CezLogo className="h-12 w-12 sm:h-14 sm:w-14 shrink-0" title={c.brand.sigla} />
            <div className="min-w-0 hidden sm:block">
              <p className="truncate text-sm font-extrabold leading-snug group-hover:text-amber-100 transition">
                {c.brand.nombre}
              </p>
              <p className="truncate text-[11px] text-slate-300">{c.brand.tagline}</p>
            </div>
            <div className="min-w-0 sm:hidden">
              <p className="text-sm font-extrabold">{c.brand.sigla}</p>
              <p className="truncate text-[11px] text-slate-300">{c.brand.tagline}</p>
            </div>
          </Link>

          <nav className="hidden lg:flex items-center gap-1">
            {c.nav.map((item) => (
              <NavLink key={item.path} to={item.path} className={linkClass}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2 sm:gap-3 shrink-0">
            <button
              type="button"
              className="lg:hidden rounded-xl border border-white/25 px-3 py-2 text-xs font-bold uppercase tracking-wide"
              onClick={() => setMobileOpen((open) => !open)}
              aria-expanded={mobileOpen}
            >
              {mobileOpen ? c.chrome.cerrarMenu : c.chrome.abrirMenu}
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="border-t border-white/10 px-4 py-4 lg:hidden">
            <p className="mb-2 text-[10px] font-bold uppercase tracking-[0.28em] text-slate-400">
              {c.chrome.menuLabel}
            </p>
            <div className="flex flex-col gap-1">
              {c.nav.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={linkClass}
                  onClick={() => setMobileOpen(false)}
                >
                  {item.label}
                </NavLink>
              ))}
            </div>
          </div>
        )}
      </header>

      <main key={location.pathname}>
        <Outlet />
      </main>
    </div>
  );
}

export default NavbarCez;
